<!-- 商城订单 -->
<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb></breadcrumb>
    </div>
    <div class="tabs-btn-ctn">
      <div
        class="tab-btn-item"
        @click="tabToggle(-1)"
        :class="{ 'tab-active': tabInd == -1 }"
      >
        全部
      </div>
      <div
        class="tab-btn-item"
        @click="tabToggle(0)"
        :class="{ 'tab-active': tabInd == 0 }"
      >
        待付款
      </div>
      <div
        class="tab-btn-item"
        @click="tabToggle(1)"
        :class="{ 'tab-active': tabInd == 1 }"
      >
        待发货
      </div>
      <div
        class="tab-btn-item"
        @click="tabToggle(2)"
        :class="{ 'tab-active': tabInd == 2 }"
      >
        待收货
      </div>

    </div>
    <div class="base-content">
      <siPurchaseOrdersList
        ref="shareInventoryPurchaseOrdersList"
        :type="tabInd"
      ></siPurchaseOrdersList>
    </div>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import siPurchaseOrdersList from "@/views/business/shareInventory/siPurchaseOrdersList";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    siPurchaseOrdersList,
    breadcrumb
  },
  data() {
    return {
      tabInd: -1
    };
  },
  watch: {
    tabInd() {
      this.$refs.siPurchaseOrdersList.getTableData(this.tabInd);
    }
  },
  mounted() {},
  methods: {
    // 切换最上面的tab
    tabToggle(i) {
      this.tabInd = i;
    }
  }
};
</script>
<style lang="less" scoped>
.base-content {
  > div {
    margin: 0 auto;
  }
}
.tabs-btn-ctn {
  border-bottom: 1px solid @border1Color;
  .tab-btn-item {
    flex-grow: 0;
    width: 120px;
    padding: 0 10px;
    border-bottom: none;
  }
}
.base-content {
  padding-top: 20px;
}
</style>
